import React from "react";
import CodeEditorMock from "./CodeEditorMock";

const MeReadPanel = () => {
  return (
    <div className="interestspanel">
      <div className="file-info">
        <div className="cell file-name">
          <i class="fa-solid fa-circle-info"></i>
          README.md
          <i class="fa-solid fa-x"></i>
        </div>
      </div>
      <div className="panel-content">
        <CodeEditorMock>
          <b className="nodejs-color-text">
            Technologies used for this website{" "}
          </b>
          <br /> <br />
          <b className="react-color-text">React:</b> Main framework for building
          the UI. <br /> <br />
          <b className="react-color-text">Context API:</b> For global state
          management across components. <br /> <br />
          <b className="js-color-text">JavaScript (ES6+):</b> Core language for
          logic and interactivity.
          <br /> <br />
          <b className="css-color-text">CSS Modules:</b> Scoped styling for
          components.
          <br /> <br />
          <b className="fontawsome-color-text">Font Awesome:</b> Icon library
          for UI elements. <br /> <br />
          <b className="react-color-text">React Router:</b> For client-side
          routing and navigation.
          <br /> <br />
          <b className="op-1">Axios:</b> For making HTTP requests to APIs.
          <br /> <br />
          <b className="nodejs-color-text">Node.js:</b> Backend server for
          handling requests and serving the React app.
        </CodeEditorMock>
      </div>
    </div>
  );
};

export default MeReadPanel;
